import { stringify } from "qs";
import Routes from "routing/Routes";
export const loadNewView = (history) => history.push(`${Routes.SEARCH}/new`);
export const loadNewSearch = loadNewView;
export const loadNewViewForStream = (history, streamId) => history.push(`${Routes.stream_search(streamId)}/new`);
export const loadView = (history, viewId) => history.push(`${Routes.SEARCH}/${viewId}`);
export const loadDashboard = (history, dashboardId, initialPage) => history.push(`${Routes.DASHBOARD.SHOW(dashboardId)}${initialPage ? `?${stringify({ page: initialPage })}` : ""}`);
export const loadAsDashboard = (history, view) => history.pushWithState(Routes.DASHBOARD.NEW, {
  view
});
